import * as React from 'react'
import styled from 'styled-components'

import { BREAKPOINTS } from '@ulule/owl-kit-components/next'

type AccordionWrapperProps = {
  children: React.ReactNode
  open: boolean
  openOnDesktop?: boolean
}

const ToggleContent = styled.div<{ open: boolean; height: number | undefined; openOnDesktop?: boolean }>`
  height: ${({ open }) => (open ? 'auto' : '0px')};
  min-height: ${({ open, height }) => (open ? height : '0')}px;
  opacity: ${({ open }) => (open ? '1' : '0')};
  overflow: hidden;
  pointer-events: ${({ open }) => (open ? 'initial' : 'none')};
  transition: 0.8s ease;

  @media screen and ${BREAKPOINTS.LAPTOP} {
    ${({ openOnDesktop }) =>
      openOnDesktop &&
      `
        height: auto;
        opacity: 1;
        pointer-events: initial;
    `}
  }
`

export function AccordionWrapper({
  children,
  open,
  openOnDesktop,
}: AccordionWrapperProps): React.ReactElement<AccordionWrapperProps> {
  const contentRef = React.useRef<HTMLDivElement>(null)
  const [toggleableHeight, setToggleableHeight] = React.useState(0)

  React.useLayoutEffect(() => {
    if (contentRef.current) {
      setToggleableHeight(contentRef.current.clientHeight)
    }
  }, [contentRef.current])

  return (
    <ToggleContent open={open} openOnDesktop={openOnDesktop} height={toggleableHeight}>
      <div ref={contentRef}>{children}</div>
    </ToggleContent>
  )
}
